import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=1be51edb&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=1be51edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be51edb",
  null
  
)

export default component.exports